export default __webpack_public_path__ + "static/media/스프링바인딩 48P - mint (48Page).13db1a10.png";